// extracted by mini-css-extract-plugin
module.exports = {"card":"card--1_Zwk","card_title_1":"card_title_1--3-zjF","active":"active--sKjYf","card_title_2":"card_title_2--1daAI","card_title_3":"card_title_3--3oV2p"};